import { __rest } from "tslib";
import * as React from "react";
function SvgChevronDown(_a) {
    var { title, titleId } = _a, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2048 2048", width: "1em", height: "1em", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { d: "M1939 467l90 90-1005 1005L19 557l90-90 915 915 915-915z" })));
}
export default SvgChevronDown;
